module.exports = __webpack_public_path__ + "b4f4b90da30103ef9cb0554e0111ea0d.svg";